import { createSelector } from 'reselect';
export const makeSelectCosmeticDetail = () => createSelector(state => state.cosmeticInventory.data, state => state.cosmeticItemsConfigs.cosmeticConfigs, state => state.selectedCosmetics.data, (cosmeticInventoryData, cosmeticConfigs, selectedCosmetics) => {
  if (!cosmeticInventoryData) {
    return cosmeticInventoryData;
  }

  const flattenSelected = selectedCosmetics && Object.values(selectedCosmetics).reduce((acc, val) => acc.concat(val), []);
  return cosmeticInventoryData.map(item => {
    const cosmeticInfo = item.cosmeticInfo ? cosmeticConfigs === null || cosmeticConfigs === void 0 ? void 0 : cosmeticConfigs[item.cosmeticInfo.typeId] : undefined;
    return cosmeticInfo ? { ...item,
      cosmeticRarity: cosmeticInfo.rarity,
      cosmeticType: cosmeticInfo.type,
      cosmeticName: cosmeticInfo.name,
      isSelected: !!(flattenSelected && flattenSelected.includes(item.id))
    } : item;
  });
});